<template>
  <div class="page-container users">
    <div class="main">
      <page :url="url" :form="form">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.loginName')">
            <el-input v-model="form.loginName" :placeholder="$t('text.loginName')" maxlength="50"/>
          </el-form-item>
        </template>

        <template slot="tableColumn">
          <el-table-column align="center" prop="loginName" :label="$t('text.loginName')"/>
          <el-table-column align="center" prop="id" :label="$t('text.userId')" width="200px"/>
          <el-table-column prop="name" :label="$t('text.name')" align="center"/>
          <el-table-column prop="roleName" :label="$t('text.role')" align="center"/>
          <el-table-column prop="whiteIp" :label="$t('text.rcsIp')" align="center"/>
          <el-table-column prop="email" :label="$t('text.eMail')" align="center"/>
          <el-table-column prop="createdAt" :label="$t('text.creationTime')" :formatter="$formatter.formatDate"
                           width="200px" align="center"/>
          <el-table-column prop="createdBy" :label="$t('text.creator')" align="center"/>
          <el-table-column prop="loginAt" :label="$t('text.loginTime')" :formatter="$formatter.formatDate" width="200px"
                           align="center"/>
<!--          <el-table-column :label="$t('text.googleKey')" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button class="google-key-button" size="small" type="danger" @click="getGoogleKey(scope.row.id)">-->
<!--                {{ $t('text.get') }}-->
<!--              </el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column fixed="right" :label="$t('text.actions')" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="danger"
                         plain
                         size="mini"
                         @click="lockedUser(scope.row)"
                         v-if="!scope.row.isLocked">
                {{ $t('text.lockUser') }}
              </el-button>
              <el-button type="primary"
                         plain
                         size="mini"
                         @click="unlockedUser(scope.row)"
                         :loading="loading"
                         v-else>
                {{ $t('text.unlockUser') }}
              </el-button>
<!--              <el-button type="warning"-->
<!--                         plain-->
<!--                         size="mini"-->
<!--                         @click="resetGoogleKey(scope.row)">-->
<!--                {{ $t('text.resetGoogleKey') }}-->
<!--              </el-button>-->
              <el-button type="primary"
                         plain
                         size="mini"
                         @click="editUser(scope.row)">
                {{ $t('text.edit') }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </page>

      <user-edit :show.sync="showUserEditor" :formData="formData" :action="action"/>
      <GoogleKeyDialog :showGoogleKeyDialog.sync="showGoogleKeyDialog" :userId="currentUserId"/>
    </div>
  </div>
</template>

<script>
import Page from "@/components/Page.vue";
import UserEdit from "@/components/auth/UserEdit.vue";
import Upload from "@/components/Upload.vue";
import GoogleKeyDialog from "@/components/auth/GoogleKeyDialog.vue";

export default {
  name: "Users",
  components: {
    GoogleKeyDialog,
    "user-edit": UserEdit,
    page: Page,
    upload: Upload,
  },

  data() {
    return {
      form: {
        loginName: "",
        systemId: "",
      },
      formData: null,
      action: null,
      url: "/sysUserInfo/selectUserList",
      showUserEditor: false,
      showGoogleKeyDialog: false,
      systemList: [],
      currentUserId: "",
      loading: false,
    };
  },

  methods: {
    // getGoogleKey(userId) {
    //   this.currentUserId = userId;
    //   this.showGoogleKeyDialog = true;
    // },
    lockedUser(row) {
      this.$confirm(
          this.$t('message.confirmLockedUser', {name: row.name}),
          this.$t('text.prompt'),
          {
            confirmButtonText: this.$t('text.confirm'),
            cancelButtonText: this.$t('text.cancel'),
            type: "warning",
          }
      )
          .then(() => {
            this.axios
                .post("/sysUserInfo/lockedUser", {id: row.id})
                .then((res) => {
                  if (res.code === 200) {
                    this.$bus.$emit("refresh"); //通知刷新
                    this.$notify({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                      type: "success",
                    });
                  } else {
                    this.$notify.error({
                      title: this.$t('text.prompt'),
                      message: res.msg,
                    });
                  }
                });
          })
          .catch(() => {
          });
    },
    unlockedUser(row) {
      this.loading = true;
      this.axios
          .post("/sysUserInfo/unlockedUser", {id: row.id})
          .then((res) => {
            if (res.code === 200) {
              this.$bus.$emit("refresh"); //通知刷新
              this.$notify({
                title: this.$t('text.prompt'),
                message: res.msg,
                type: "success",
              });
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: res.msg,
              });
            }
          }).finally(() => {
        this.loading = false;
      });
    },
    // deleteRole(row) {
    //   this.$confirm(
    //       this.$t('message.confirmDeletingRole', {name: row.name, role: row.roleName}),
    //       this.$t('text.prompt'),
    //       {
    //         confirmButtonText: this.$t('text.confirm'),
    //         cancelButtonText: this.$t('text.cancel'),
    //         type: "warning",
    //       }
    //   )
    //       .then(() => {
    //         this.axios
    //             .post("/sysUserInfo/deleteRole", {id: row.id, roleId: row.roleId})
    //             .then((res) => {
    //               if (res.code === 200) {
    //                 this.$bus.$emit("refresh"); //通知刷新
    //                 this.$notify({
    //                   title: this.$t('text.prompt'),
    //                   message: res.msg,
    //                   type: "success",
    //                 });
    //               } else {
    //                 this.$notify.error({
    //                   title: this.$t('text.prompt'),
    //                   message: res.msg,
    //                 });
    //               }
    //             });
    //       })
    //       .catch(() => {
    //       });
    // },

    editUser(row) {
      this.action = "editUser";
      this.formData = row;
      this.showUserEditor = true;
    },

    add() {
      this.action = "addUser";
      this.formData = null;
      this.showUserEditor = true;
    },

    // resetGoogleKey(row) {
    //   this.$confirm(
    //       this.$t('message.confirmResetGoogleKey'),
    //       this.$t('text.prompt'),
    //       {
    //         confirmButtonText: this.$t('text.confirm'),
    //         cancelButtonText: this.$t('text.cancel'),
    //         type: "warning",
    //       }
    //   )
    //       .then(() => {
    //         this.axios
    //             .post("/sysUserInfo/resetUserGoogleKey", {id: row.id})
    //             .then((res) => {
    //               if (res.code === 200) {
    //                 this.$notify({
    //                   title: this.$t('text.prompt'),
    //                   message: res.msg,
    //                   type: "success",
    //                 });
    //               } else {
    //                 this.$notify.error({
    //                   title: this.$t('text.prompt'),
    //                   message: res.msg,
    //                 });
    //               }
    //             });
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //         this.$notify.error({
    //           title: this.$t('text.prompt'),
    //           message: this.$t('text.resetFailed')
    //         });
    //       });
    // },
  },
  created() {
  },
};
</script>

<style scoped>
</style>